<div class="ab-list-item-inner flex w-100 activity-type--upload">
  <span class="ab-list-item__icon">
    <span class="ab-fa-stacked--v2">
      <i class="icon fal fa-pen-to-square ab-stacked-icon"></i>
      <i class="icon fal fa-share-alt ab-stacked-icon with-shadow--white"></i>
    </span>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span>
      added / updated the following connection from a list of {{payload.entitiesAffected}} entities using bulk edit.
    </div>
    <div class="details"
         *ngIf="entityConnectionType">
      <app-connection-type-name [connectionType]="entityConnectionType"></app-connection-type-name>
      <a [routerLink]="['/entity/view', entity?.id]"
         queryParamsHandling="preserve"
         class="attached-user user-profile-link ml-0050">{{entity | fullName}}</a>
      <ng-container *ngIf="appliedTags?.length > 0">
        <div>Responses Applied:</div>
        <div class="ab-list-group">
          <div class="ab-list-item pt-0050 pb-0050"
               *ngFor="let tag of appliedTags">
            <i class="fal fa-tag color--turq"></i>
            <div class="ml-0050">
              <strong class="d-block">{{ tag | tagSelectLabel }}</strong>
              <span class="caps color--gray txt-12">
                <app-type-name-label [type]="tag.targetType"></app-type-name-label> >
                {{ tag?.category?.groupName }} >
                {{ tag?.category?.name }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="removedTags?.length > 0">
        <div>Responses Removed:</div>
        <div class="ab-list-group">
          <div class="ab-list-item pt-0050 pb-0050"
               *ngFor="let tag of appliedTags">
            <i class="fal fa-tag color--turq"></i>
            <div class="ml-0050">
              <strong class="d-block">{{ tag | tagSelectLabel }}</strong>
              <span class="caps color--gray txt-12">
                <app-type-name-label [type]="tag.targetType"></app-type-name-label> >
                {{ tag?.category?.groupName }} >
                {{ tag?.category?.name }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>


  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
